import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetPendingStatus[]): Array<object> => {
  const dataTableData: Array<object> = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPendingStatus = async ( {data} : {data: submitFilterDTO | {}}): Promise<Array<object>> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Pending_Status`, data);
  return convertToDataTable(response as unknown as IGetPendingStatus[]);
};

type QueryFnType = typeof getAllPendingStatus;

type UseGetAllPendingStatusOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPendingStatus = ({ data, config }: UseGetAllPendingStatusOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPendingStatus'],
    queryFn: () => getAllPendingStatus({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};